import { render, staticRenderFns } from "./step2DialogSub.vue?vue&type=template&id=3227ff5f&"
import script from "./step2DialogSub.vue?vue&type=script&lang=js&"
export * from "./step2DialogSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports